
import React from 'react';
import { Image, ImageOff } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface HeroImageStatusProps {
  imageUrl?: string | null;
}

export const HeroImageStatus: React.FC<HeroImageStatusProps> = ({ imageUrl }) => {
  const hasImage = !!imageUrl;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex items-center gap-2">
            {hasImage ? (
              <>
                <div className="flex items-center">
                  <Image size={16} className="text-green-600" />
                  <div className="w-2 h-2 bg-green-500 rounded-full ml-1"></div>
                </div>
                <span className="text-xs text-green-600 truncate max-w-[100px]">
                  {hasImage ? 'Loaded' : 'None'}
                </span>
              </>
            ) : (
              <>
                <div className="flex items-center">
                  <ImageOff size={16} className="text-orange-500" />
                  <div className="w-2 h-2 bg-orange-500 rounded-full ml-1"></div>
                </div>
                <span className="text-xs text-orange-500">Missing</span>
              </>
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          {hasImage 
            ? <div className="max-w-xs">
                <p>Hero image is set</p>
                <p className="text-xs mt-1 text-muted-foreground break-words">{imageUrl}</p>
              </div>
            : 'No hero image configured'
          }
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
